export enum LogoColor {
  Light = 'light',
  Dark = 'dark',
  TransparentLight = 'transparent-light',
  TransparentDark = 'transparent-dark',
}

export default LogoColor;
